import "leaflet/dist/leaflet.css";
import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import { CATEGORY_MAP } from "@/lib/categories";

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length) map.fitBounds(points.map((p) => [p.lat, p.lng]), { padding: [40, 40], maxZoom: 14 });
  }, [points, map]);
  return null;
}

export function MapView({ items, onOpen }) {
  const points = items.filter((i) => typeof i.lat === "number" && typeof i.lng === "number");
  if (!points.length) return <p data-testid="map-empty" className="text-slate-400 py-16 text-center">No map locations for these listings yet.</p>;

  return (
    <div data-testid="map-view" className="h-[70vh] rounded-3xl overflow-hidden border border-[#26334D] relative z-0">
      <MapContainer center={[points[0].lat, points[0].lng]} zoom={12} className="h-full w-full" scrollWheelZoom={false}>
        <TileLayer className="vv-dark-tiles" attribution='&copy; OpenStreetMap contributors' url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FitBounds points={points} />
        {points.map((p) => (
          <CircleMarker key={p.id} center={[p.lat, p.lng]} radius={p.featured ? 11 : 8}
            pathOptions={{ color: p.featured ? "#FFB800" : "#FF3B6B", fillColor: p.featured ? "#FFB800" : "#FF3B6B", fillOpacity: 0.85, weight: 2 }}>
            <Popup>
              <div className="min-w-[160px]">
                <p className="text-[11px] uppercase tracking-wide text-slate-500">{CATEGORY_MAP[p.category]?.label}</p>
                <p className="font-semibold text-sm text-slate-900">{p.name}</p>
                <button data-testid={`map-open-${p.id}`} onClick={() => onOpen(p)} className="mt-2 text-xs font-semibold text-[#E02E5A]">View details →</button>
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
